import { Component } from '@angular/core';
import { JsxgraphComponent, type JsxgraphBoard } from '@examdojo/core/jsxgraph';

@Component({
  selector: 'dojo-slider-example',
  standalone: true,
  imports: [JsxgraphComponent],
  template: `
    <div class="grid h-full w-full gap-4 p-4" style="grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));">
      <div class="flex flex-col gap-2">
        <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-300">Sine Wave with Slider</h3>
        <div class="h-full min-h-[400px]">
          <dojo-jsxgraph [boardId]="'slider-board-1'" [options]="boardOptions" (boardReady)="onBoard1Ready($event)" />
        </div>
      </div>

      <div class="flex flex-col gap-2">
        <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-300">Cosine Wave with Slider</h3>
        <div class="h-full min-h-[400px]">
          <dojo-jsxgraph [boardId]="'slider-board-2'" [options]="boardOptions" (boardReady)="onBoard2Ready($event)" />
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        @apply block h-full w-full overflow-auto;
      }
    `,
  ],
  host: { class: 'block h-full w-full' },
})
export class SliderExampleComponent {
  readonly boardOptions = {
    boundingbox: [-1, 10, 11, -1] as [number, number, number, number],
    axis: true,
    showNavigation: false,
    showCopyright: false,
  };

  onBoard1Ready(board: JsxgraphBoard): void {
    const slider = board.create(
      'slider',
      [
        [1, 8],
        [6, 8],
        [0, 2, 4],
      ],
      {
        name: 'n',
        snapWidth: 0.1,
      },
    );

    board.create(
      'functiongraph',
      [(x: number) => Math.sin((slider as unknown as { Value: () => number }).Value() * x), 0, 10],
      {
        strokeColor: '#ff6b6b',
        strokeWidth: 2,
      },
    );

    board.create('text', [1, 9, () => `Value: ${(slider as unknown as { Value: () => number }).Value().toFixed(2)}`], {
      fontSize: 14,
    });
  }

  onBoard2Ready(board: JsxgraphBoard): void {
    const slider = board.create(
      'slider',
      [
        [1, 8],
        [6, 8],
        [0, 2, 4],
      ],
      {
        name: 'm',
        snapWidth: 0.1,
      },
    );

    board.create(
      'functiongraph',
      [(x: number) => Math.cos((slider as unknown as { Value: () => number }).Value() * x), 0, 10],
      {
        strokeColor: '#4ecdc4',
        strokeWidth: 2,
      },
    );

    board.create('text', [1, 9, () => `Value: ${(slider as unknown as { Value: () => number }).Value().toFixed(2)}`], {
      fontSize: 14,
    });
  }
}
